import models from './models';
import { connect } from 'react-redux';

const _inject = (model_name, state) => {
    let props = state[model_name];
    for (let i in models[model_name]) {
        //Cause of eslint we are adding Object.prototype methods. otherwise we are only using hasOwnProperty
        if (Object.prototype.hasOwnProperty.call(models[model_name], i)) {
            props[i] = models[model_name][i];
        }
    }
    return props;
};

export const injectModels = model_names => {
    return Component => {
        let mapStateToProps = (state) => {
            let props = {};
            model_names.forEach(model_name => {
                props[model_name] = _inject(model_name, state);
            });

            return props;
        };
        return connect(mapStateToProps)(Component);
    };
};


